import { Box, Typography } from '@mui/material';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import FlashOnRoundedIcon from '@mui/icons-material/FlashOnRounded';
import WorkspacePremiumRoundedIcon from '@mui/icons-material/WorkspacePremiumRounded';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import StaticPage from '../../components/StaticPage';
import ProfileSection from '../../components/ProfileSection';

const highlights = [
    {
        icon: <GroupsRoundedIcon fontSize="small" />,
        title: 'Built for both sides of the deal',
        body: 'One platform for brands scouting talent and creators managing their rates and platforms, instead of juggling spreadsheets and DMs.',
    },
    {
        icon: <AutoAwesomeRoundedIcon fontSize="small" />,
        title: 'AI-assisted matching',
        body: 'The AI Bot narrows down thousands of possible creators to a short, relevant list based on what you actually asked for.',
    },
    {
        icon: <FlashOnRoundedIcon fontSize="small" />,
        title: 'Live data, not stale lists',
        body: 'Live AI Search pulls current posts and stats on demand, so you are working from real numbers rather than a directory that has not been updated in months.',
    },
    {
        icon: <WorkspacePremiumRoundedIcon fontSize="small" />,
        title: 'Signals that matter',
        body: 'Top Creator and Responds Fast badges, plus engagement and sentiment where available, help you shortlist quickly.',
    },
];

export default function HighlightsPage() {
    return (
        <StaticPage title="Highlights" subtitle="Why brands and creators choose The Creator Match.">
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                {highlights.map((h) => (
                    <ProfileSection key={h.title} icon={h.icon} title={h.title} sx={{ mb: 0 }}>
                        <Typography color="text.secondary">{h.body}</Typography>
                    </ProfileSection>
                ))}
            </Box>
        </StaticPage>
    );
}
